export default "__VITE_ASSET__BVQx6$OL__"